module.exports = __webpack_public_path__ + "static/lemonwaffle-5ec744712d029257017d80c2ae87c536.jpeg";